import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import { InfoItemProps } from '../../types/interfaces';
import CopyTextIcon from '../../components/CopyTextIcon/CopyTextIcon';
import { shortenAddress } from '../../utils';

interface ExtendedInfoItemProps extends InfoItemProps {
  showFullValue?: boolean;
}

const InfoItem = ({ label, value, icon, showFullValue = false }: ExtendedInfoItemProps) => {
  const [isExpanded, setIsExpanded] = useState(showFullValue);
  const displayValue = value || '';

  const handleValueClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <Typography variant='body1' color='grey' className='font-medium'>
        {label}
      </Typography>
      <div className={`flex gap-2 ${isExpanded ? 'items-start' : 'items-center'}`}>
        <Typography
          variant='body1'
          color='black'
          className={`semibold cursor-pointer hover:text-blue-600 ${
            isExpanded ? 'max-w-[20ch] break-all' : ''
          }`}
          onClick={handleValueClick}
        >
          {isExpanded ? displayValue : shortenAddress(displayValue, 8, 8)}
        </Typography>
        {icon && (
          <CopyTextIcon textToCopy={value || ''}>
            <img src={icon} alt='Copy' />
          </CopyTextIcon>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
